<div class="login-div">
  <mat-card appearance="outlined" class="login-card">
    <mat-card-content class="login-container">
      <div class="login-header">
        <img src="assets/img/crea-logo-blue.png" class="login-logo" />
        <div class="login-title" color="primary">Sign In</div>
        <div class="login-subtitle">to CREAWeb</div>
      </div>
    </mat-card-content>

    <mat-card-actions>
      <mat-grid-list cols="1" rowHeight="40px" style="width: 100% !important">
        @if (!logging_in) {
          <mat-grid-tile style="width: 100% !important">
            <button
              mat-raised-button
              color="primary"
              (click)="ssoRedirect()"
              style="margin-left: auto"
              >
              Sign In
            </button>
          </mat-grid-tile>
        }
        @if (logging_in) {
          <mat-grid-tile>
            <span style="margin-left: auto">Signing In...</span>
          </mat-grid-tile>
        }
      </mat-grid-list>
    </mat-card-actions>
  </mat-card>
</div>
